import { ApiResult, ApiResultError } from "@shoothill/core";
import { IApiCallOptions } from "./Types";

export class ApiService {
    async executeCall<TPayload = ApiResult<undefined>>(apiCall: () => Promise<ApiResult<TPayload>>, options?: IApiCallOptions<TPayload>): Promise<ApiResult<TPayload>> {
        try {
            const result = await apiCall();

            if (result.wasSuccessful) {
                await this.handleApiSuccess(result, options);
            } else {
                this.handleApiError(result.errors, options);
            }

            return result;
        } catch (error: any) {
            const errors = error?.errors ?? error?.response?.data?.errors ?? [];
            this.handleApiError(errors, options);
            throw error;
        }
    }

    private async handleApiSuccess<TPayload>(result: ApiResult<TPayload>, options?: IApiCallOptions<TPayload>): Promise<void> {
        if (options?.onSuccess) {
            await options.onSuccess(result.payload);
        }
    }

    private handleApiError(errors: ApiResultError[], options?: IApiCallOptions<any>): void {
        if (options?.onError) {
            options.onError(errors);
        }
    }
}
